module.exports = __webpack_public_path__ + "static/media/cvCalendar.cb0fdfd3.svg";